import type { YscApiError } from './YscApiError'

export const isErrorCausedByRentalCoverUnavailability = (error: YscApiError) => {
  return error.apiStatus === 503
    && error.apiResponseErrorData
    && typeof error.apiResponseErrorData === 'object'
    && 'code' in error.apiResponseErrorData
    && error.apiResponseErrorData.code === 'RENTAL_COVER_SERVICE_UNAVAILABLE'
}
